module.exports = __webpack_public_path__ + "img/gongjian.prt.edba2044.jpg";